/**
 * Our own uploads: frame content stores them as the backend's relative
 * `/api/v1/uploads/<uuid>/image/` path, which the web app reads on its own
 * origin and the desktop app on its API host. Nothing else counts as one.
 */
import { resolveApiUrl } from "@/api/client";

const UPLOAD_PATH =
  /^\/api\/v1\/uploads\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/image\/$/i;

function absolute(path: string): URL {
  return new URL(resolveApiUrl(path), window.location.origin);
}

/**
 * The absolute URL of the upload `raw` names, resolved for this platform,
 * or null when `raw` is not exactly an upload path.
 */
export function ownUploadUrl(raw: unknown): string | null {
  if (typeof raw !== "string" || !UPLOAD_PATH.test(raw)) return null;
  return absolute(raw).href;
}

/** True when absolute `url` is one of our uploads on this platform's API host. */
export function isOwnUploadUrl(url: string): boolean {
  try {
    const target = new URL(url);
    return (
      target.origin !== "null" &&
      target.origin === absolute("/").origin &&
      UPLOAD_PATH.test(target.pathname) &&
      target.search === "" &&
      target.username === "" &&
      target.password === ""
    );
  } catch {
    return false;
  }
}
